<template>
    <div class="card">
        <div class="card-header bg-secondary d-flex justify-content-between" v-if="abono.asiento">
            <div>
                <span>{{ n_abono }} <br></span>
                <template v-if="abono.plaza">
                    <span v-if="abono.plaza.region_name">{{ abono.plaza.region_name }} <br></span>
                    <template v-if="abono.plaza.fila && abono.plaza.butaca">
                        Fila: {{ abono.plaza.fila }} / Butaca: {{ abono.plaza.butaca }}
                    </template>
                    <template v-else>
                        Plaza: {{ abono.plaza.numero }}
                    </template>
                    <span v-if="abono.plaza.visibilidad_reducida || abono.plaza.porcentaje_visibilidad">
                        &nbsp;-&nbsp;
                    </span>
                    <span v-if="abono.plaza.visibilidad_reducida" class="text-danger">
                        {{ $t('visibilidad_reducida.nombre') }}
                    </span>
                    <span v-if="abono.plaza.porcentaje_visibilidad" class="text-danger">
                        : {{ abono.plaza.porcentaje_visibilidad }}%
                    </span>
                </template>
                <template v-else-if="abono.asiento">
                    {{ abono.asiento.zona_nombre }} <br>
                    Fila: {{ abono.asiento.fila }} / Butaca: {{ abono.asiento.asiento }}
                    <span v-if="abono.asiento.visibilidad_reducida || abono.asiento.porcentaje_visibilidad">
                        &nbsp;-&nbsp;
                    </span>
                    <span v-if="abono.asiento.visibilidad_reducida" class="text-danger">
                        {{ $t('visibilidad_reducida.nombre') }}
                    </span>
                    <span v-if="abono.asiento.porcentaje_visibilidad" class="text-danger">
                        : {{ abono.asiento.porcentaje_visibilidad }}%
                    </span>
                </template>
            </div>
            <div class="m-0 ml-auto"><Button class="button small-button" type="button" @click="$emit('borrar')" :disabled="desactivar">Eliminar</Button></div>
        </div>
        <div class="card-header bg-secondary d-flex justify-content-between" v-else-if="abono.plaza">
            <div>
                <span>{{ n_abono }}. </span>
                {{ abono.plaza.plazaName }}
            </div>
            <div class="m-0 ml-auto"><Button class="button small-button" type="button" @click="$emit('borrar')" :disabled="desactivar">Eliminar</Button></div>
        </div>
        <div class="card-header bg-secondary d-flex" v-else>
            <span>Abono - {{ n_abono }}</span>
            <div class="m-0 ml-auto"><Button class="button small-button" type="button" @click="$emit('borrar')" :disabled="desactivar">Eliminar</Button></div>
        </div>
        <div class="card-body">
            <label for="obtener">Obtener datos de abonado existente</label>
            <div class="input-group">
                <input name="obtener" type="text" class="form-control" placeholder="Introduce nº de abonado" v-model="buscar">
                <span class="input-group-append">
                    <Button @click.prevent="buscarAbonado()" type="button" class="btn-flat" :disabled="desactivar">Obtener</Button>
                </span>
            </div>
            <hr>
            <template v-if="!loading">
                <div class="form-group">
                    <label for="nombre">Nombre</label>
                    <ValidationProvider :name="'nombre' + index" rules="required" v-slot="{ errors }">
                        <input :disabled="desactivar" type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="Nombre" v-model="abono.nombre" @change="actualizado">
                    </ValidationProvider>
                </div>
                <div class="form-group">
                    <label for="apellidos">Apellidos</label>
                    <ValidationProvider :name="'apellidos' + index" rules="required" v-slot="{ errors }">
                        <input :disabled="desactivar" type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="Apellidos" v-model="abono.apellidos" @change="actualizado">
                    </ValidationProvider>
                </div>
                
                <div class="form-group">
                    <label for="genero">Género</label>
                    <ValidationProvider :name="'generos' + index" rules="required" v-slot="{ errors }">
                        <select :disabled="desactivar" :id="'genero' + index" name="genero" v-model="abono.genero_id" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" @change="actualizado">
                            <template v-for="(genero, index) in generos">
                                <option :key="index" :value="genero.id">
                                    {{ genero.name }}
                                </option>
                            </template>
                        </select>
                    </ValidationProvider>
                </div>

                <div class="form-group">
                    <label for="dni">Dni</label>
                    <ValidationProvider :name="'dni' + index" rules="required" v-slot="{ errors }">
                        <input :disabled="desactivar" type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="Dni" v-model="abono.dni" @change="actualizado">
                    </ValidationProvider>
                </div>
                <div class="form-group">
                    <label for="fecha_nacimiento">Fecha de nacimiento</label>
                    <ValidationProvider :name="'fecha_nacimiento' + index" rules="required" v-slot="{ errors }">
                        <input :disabled="desactivar" type="date" max="9999-12-31" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="Fecha de nacimiento" v-model="abono.fecha_nacimiento" @change="actualizado">
                    </ValidationProvider>
                </div>
                <div class="form-group">
                    <label for="email">Email</label>
                    <ValidationProvider :name="'email' + index" rules="required|email" v-slot="{ errors }">
                        <input :disabled="desactivar" type="email" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="Email" v-model="abono.email" @change="actualizado">
                    </ValidationProvider>
                </div>
                <div class="form-group mb-4">
                    <label for="telefono">Teléfono</label>
                    <PhoneInput
                        :name="'telefono' + index" 
                        :phone="abono.telefono ?? null" 
                        :desactivar="desactivar" 
                        :required="true"
                        @setNumber="(number) => abono.telefono = number"
                        @validNumber="(valid) => handleValidNumber(valid)"
                    />
                </div>
                <div v-if="mostrar_iban == true" class="form-group">
                    <label for="iban">IBAN</label>
                    <ValidationProvider :name="'iban' + index" rules="required" v-slot="{ errors }">
                        <input :disabled="desactivar" type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="IBAN" v-model="abono.iban" @change="actualizado">
                    </ValidationProvider>
                </div>
                <div v-if="mostrar_titular_cuenta == true" class="form-group">
                    <label for="titular_cuenta">Titular de la cuenta</label>
                    <ValidationProvider :name="'titular_cuenta' + index" rules="required" v-slot="{ errors }">
                        <input :disabled="desactivar" type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="Titular de la cuenta" v-model="abono.titular_cuenta" @change="actualizado">
                    </ValidationProvider>
                </div>

                <div class="form-group">
                    <Paises :desactivar="desactivar" :errors="errors" @rellenarPais="rellenarPais" @selected="opt => { pais = opt; abono.pais = opt.nombre; actualizado(); }"/>
                </div>
                <div class="form-group">
                    <Provincias :desactivar="desactivar" :errors="errors" :pais="pais.id" :provincia="provincia" @selected="opt => { provincia = opt; abono.provincia = opt; actualizado(); }"/>
                </div>
                <div class="form-group">
                    <Locations :desactivar="desactivar" :provincia="provincia" :errors="errors" @selected="opt => { abono.localidad = opt; actualizado(); }"/>
                </div>
                <div class="form-group">
                    <label for="domicilio">Domicilio completo</label>
                    <ValidationProvider :name="'domicilio' + index" rules="required" v-slot="{ errors }">
                        <input :disabled="desactivar" type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="Domicilio" v-model="abono.domicilio" @change="actualizado">
                    </ValidationProvider>
                </div>
                <div class="form-group">
                    <label for="cp">CP/ZIP CODE</label>
                    <ValidationProvider :name="'cp' + index" rules="numeric" v-slot="{ errors }">
                        <input :disabled="desactivar"
                               type="number"
                               :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                               maxlength="5"
                               minlength="5"
                               placeholder="CP/ZIP CODE"
                               v-model="abono.cp"
                               @change="actualizado">
                    </ValidationProvider>
                </div>
                <div class="form-group">
                    <label for="empresa">Compañía / Actividad</label>
                    <input :disabled="desactivar" type="text" class="form-control" placeholder="Peña/Empresa" v-model="abono.penista" @change="actualizado">
                </div>
                <template v-if="fields && fields.length > 0">
                    <div v-for="(field, index) in fields" :key="index" class="form-group">
                        <FieldComponent 
                            :field="field" 
                            :desactivar="desactivar" 
                            v-model="abono.properties[field.name]"
                        />
                    </div>
                </template>
                <div class="form-group">
                    <label for="area">Tipo de abono</label>
                    <ValidationProvider :name="'area' + index" rules="required" v-slot="{ errors }">
                        <select :disabled="desactivar" id="tipo-abono" name="area" v-model="abono.area" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" @change="actualizado">
                            <template v-for="(precio, index) in precios">
                                <option :key="index" :value="precio">
                                    <span v-if="precio.renovacion">(Renovación) - </span>
                                    {{ precio.descripcion }}
                                </option>
                            </template>
                        </select>
                    </ValidationProvider>
                </div>

                <div class="form-group" v-if="abono.area && abono.area.descuentos && abono.area.descuentos.length > 0">
                    <label for="precio">Precio</label>
                    <ValidationProvider :name="'precio' + index" rules="required" v-slot="{ errors }">
                        <select :disabled="desactivar" id="precio" name="precio" v-model="abono.precio" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" @change="actualizado">
                            <template v-for="(descuento, index) in abono.area.descuentos">
                                <option :key="index" :value="descuento">
                                    {{ descuento.label_taquilla }}
                                </option>
                            </template>
                        </select>
                    </ValidationProvider>
                </div>
                <template v-if="permisos['venta.descuento']">
                    <DescuentoComponent :data="abono" :index="index" :desactivar="desactivar" :importe="abono.precio ? abono.precio.precio : 0"></DescuentoComponent>
                </template>
                <div class="form-group">
                    <label for="observaciones">Observaciones</label>
                    <textarea :disabled="desactivar" class="form-control" rows="3" placeholder="Observaciones..." v-model="abono.observaciones" @change="actualizado"></textarea>
                </div>

                <b-col cols="12" class="mb-3" v-if="teatro.hash === 'J1fKG9AarPuPNJ5hwY0t' && teatro.nombre === 'Real Murcia CF'">
                <hr />
                <h4>¡Murcianista!</h4>
                <p>Esta temporada elige uno de los segundos que forman cada partido en nuestro estadio.</p>
                <p>Si en ese segundo el Real Murcia C.F. consigue marcar un gol, dar una asistencia, tirar al palo, forzar su primer córner o le pitan un penalti a favor, recibirás un regalo.</p>
                <p>Únicamente tendrás que elegir un número del 1 al 5580 (minuto 93) y si este no ha sido elegido será tuyo durante toda la temporada.</p>
                
                <b-row>
                    <b-col lg="12">
                        <ValidationProvider :name="'segundo_elegido' + index" :mode="manualMode" v-slot="{ errors }">
                            <label for="segundo_elegido">Escribe Tu segundo</label>
                            <input
                                type="number" 
                                v-model="abono.segundo_elegido"
                                id="segundo_elegido" 
                                name="segundo_elegido" 
                                min="1" 
                                max="5580"
                                class="form-control"
                                @input="debouncedValidarSegundos(abono.segundo_elegido)"
                                :disabled="desactivar"
                            >
                            <span v-if="errors[0]" class="invalid-feedback mb-2 text-xs error-message"><b>{{ errors[0] }}</b></span>                        
                        </ValidationProvider>
                        <label for="segundos_sugeridos" v-if="segundos_sugeridos.length > 0">Segundos sugeridos disponibles</label>
                        <div v-if="segundos_sugeridos.length > 0">
                            <b-button 
                                v-for="(segundo, index) in segundos_sugeridos" 
                                :key="index" 
                                variant="outline-primary" 
                                class="m-1"
                                @click="() => { abono.segundo_elegido = segundo; debouncedValidarSegundos(abono.segundo_elegido); }"
                            >
                                {{ segundo }}
                            </b-button>
                        </div>
                    </b-col>
                    <b-col lg="12" v-if="abono.segundo_elegido" class="mt-4 mb-2 text-center">
                        <span class="price price-large">⏰ {{ formatSeg(abono.segundo_elegido) }}</span>
                    </b-col>
                </b-row>
            </b-col>
                <div class="form-group" v-if="teatro.url_whatsapp_abonos">
                    <div class="checkbox-container py-2">
                        <input class="custom-control-input" type="checkbox" v-model="abono.enviar_whatsapp" :id="'enviar_whatsapp' + index" :disabled="desactivar">
                        <label :for="'enviar_whatsapp' + index">Enviar por WhatsApp</label>
                    </div>
                </div>
                <div class="form-group">
                    <DatosLegales :index="index" :abono="abono" :font_size="'16'" :text_align="'left'" :disabled="desactivar"/>
                </div>
            </template>
            <template v-else>
                <LoaderComponent></LoaderComponent>
            </template>
        </div>
    </div>
</template>

<script>
import Provincias from "../../../common/forms/Provincias";
import Locations from "../../../common/forms/Locations";
import Paises from "../../../common/forms/Paises";
import FieldComponent from '@/components/common/FieldComponent';
import DatosLegales from '@/components/backend/abonados/DatosLegales.vue';
import DescuentoComponent from "../../components/DescuentoComponent.vue";
import PhoneInput from '@/components/common/PhoneInput.vue';

export default {
    props: ['abono', 'generos', 'index', 'precios', 'area', 'zona', 'desactivar', 'validator'],
    data() {
        return {
            buscar: '',
            loading: false,
            errors: [],
            provincia: null,
            pais: { id: 0 },
            mostrar_iban: this.$store.getters.getTeatro.mostrar_iban,
            mostrar_titular_cuenta: this.$store.getters.getTeatro.mostrar_titular_cuenta,
            segundos_sugeridos: []
        }
    },
    created() {
        this.abono.privacidad = true;
        this.abono.condiciones = true;
        this.abono.comunicaciones = true;

        if (!this.abono.telefono) {
            this.$set(this.abono, 'telefono', '');
        }

        if(this.$route.query.n_abonado_antiguo && this.n_abono == 1) {
            this.buscar = this.$route.query.n_abonado_antiguo;
            this.buscarAbonado();
        }

        this.abono.descuento_aplicado = 0;
        this.abono.descuento_integro = 0;
        if (this.precios && this.precios.length == 1) {
            this.abono.area = this.precios[0];
            if (this.abono.area.descuentos && this.abono.area.descuentos.length == 1) {
                this.abono.precio = this.abono.area.descuentos[0]
                if (this.abono.area.activar_pago_plazos) {
                    this.abono.area.descuentos[0].activar_pago_plazos = this.abono.area.activar_pago_plazos;
                    this.abono.area.descuentos[0].min_cantidad_plazos =  this.abono.area.min_cantidad_plazos;
                    this.abono.area.descuentos[0].max_cantidad_plazos = this.abono.area.max_cantidad_plazos;
                    this.abono.area.descuentos[0].frecuencias = this.abono.area.frecuencias[0]

                    this.abono.precio = this.abono.area.descuentos[0]
                }
            }
        }

        if (this.teatro.provincia) {
            this.provincia = this.teatro.provincia;
            this.abono.provincia = this.teatro.provincia;
            this.actualizado();
        }

        if (this.abono.provincia) {
            this.provincia = this.abono.provincia;
        }

        this.abono.properties = {};

        this.debouncedValidarSegundos = _.debounce(this.validarSegundos, 500);
    },
    computed: {
        n_abono() {
            return parseInt(this.index) + 1;
        },
        manager() {
            return this.$store.getters.getFooter;
        },
        configuracion() {
            return this.$store.getters.getConfig;
        },
        permisos() {
            return this.$store.getters.getPermisos;
        },
        teatro() {
            return this.$store.getters.getTeatro;
        },
        lista_id() {
            return this.$store.getters.getListaId;
        },
        fields() {
            return this.$store.getters.getListaAbonados.fields;
        }
    },
    mounted() {
        if (this.precios) {
            if(!this.abono.area) {
                this.abono.area = this.precios[0];
            }
            this.precios.forEach(precio => {
                if(this.zona && precio.descripcion.toUpperCase() === this.zona.name.toUpperCase()) {
                    this.abono.area = precio;
                }
            });
        } 
        this.actualizado();
    },
    methods: {
        manualMode() {
            return {};
        },
        handleValidNumber(valid) {
            this.$emit('isValidNumber', { index: this.index, valid });
        },
        buscarAbonado() {
            this.loading = true;

            const params = {
                lista_id: this.lista_id,
                filters : {
                    n_abonado_antiguo: this.buscar,
                    n_abonado_antiguo_single: this.buscar
                }
            };

            this.$store.dispatch(this.config.getVuexAlias('back.lista.abonados.renovacion'), params).then(res => {
                this.$nextTick(function() {
                    this.abono.nombre = res.data.data.name;
                    this.abono.apellidos = res.data.data.surnames;
                    this.abono.dni = res.data.data.dni;
                    this.abono.es_nuevo = false;
                    this.abono.telefono = res.data.data.telefono;
                    this.abono.fecha_nacimiento = res.data.data.fecha_nacimiento;
                    this.abono.email = res.data.data.email;
                    this.abono.provincia = res.data.data.provincia;
                    this.abono.localidad = res.data.data.localidad;
                    this.abono.domicilio = res.data.data.domicilio;
                    this.abono.penista = res.data.data.penista;
                    this.abono.observaciones = res.data.data.observaciones;
                    this.abono.n_abonado_antiguo = res.data.data.n_abonado_antiguo;
                    this.abono.cp = res.data.data.cp;
                    this.abono.importe_monedero = res.data.data.importe_monedero;
                });

            }).finally(() => this.loading = false);
        },
        rellenarPais(pais) {
            this.abono.pais = pais.nombre;
            this.$emit('actualizado');
        },
        actualizado() {
            this.$emit('actualizado');
        },
        validarSegundos(segundos) {
            const fieldName = 'segundo_elegido' + this.index;

            this.validator.setErrors({ [fieldName]: [] });

            if (segundos > 5580) {
                this.validator.setErrors({
                    [fieldName]: ['El segundo seleccionado supera el máximo permitido (5580 segundos).']
                });
                return;
            }

            const params = {
                lista_id: this.lista_id,
                filters: {},
                segundo_elegido: segundos,
            };

            this.$store
                .dispatch(this.config.getVuexAlias('front.temporada.segundos.disponible'), params)
                .then(() => {
                    this.validator.setErrors({ [fieldName]: [] });
                    this.segundos_sugeridos = []; 
                })
                .catch(error => {
                    this.segundos_sugeridos = error.response.data.segundos_sugeridos;
                    this.validator.setErrors({
                        [fieldName]: ['El segundo seleccionado no está disponible.'],
                    });
                });
        },
        formatSeg(segundo) {
            const minutes = Math.floor(segundo / 60);
            const remainingSeconds = segundo % 60;
            return `Min: ${minutes} - Seg: ${remainingSeconds}`;
        },
    },
    components: {
        Locations,
        Provincias,
        Paises,
        DatosLegales,
        DescuentoComponent,
        PhoneInput,
        FieldComponent
    }
}
</script>

<style scoped>
    .price-large {
        font-size: 40px !important;
        margin-bottom: 4em;
    }
    .price {
        margin-bottom: 4em;
    }
    .espacio {
        justify-content: center;
        align-items: center;
    }
    .my-auto {
        padding-top: 1em;
        padding-bottom: 1em;
        margin-top: 20em;
        font-family: 'Noway';
    }
    hr{
        width: 100%;
        height: 2px;
        margin-top: 1em;
        margin-bottom: 1em;
    }
    @media (max-width: 768px) {
        .price-large {
            font-size: 30px !important;
            margin-left: 0px;
        }
    }
    .error-message {
        font-size: 11px;
        display: block;
        background-color: #DC3545;
        color: white;
        padding: 6px;
    }
</style>
